import HistoryList from './HistoryList';

export default HistoryList;
